import React from "react";
import "./Junkremovaldetails.css";
import { FiTrash } from "react-icons/fi";
import junk from "../../Assests/service7.webp";

const Junkremovaldetails = () => {
  return (
    <section className="Junkremovaldetails-section">
      <div className="Junkremovaldetails-container">
        {/* Content Column */}
        <div className="Junkremovaldetails-content">
          <div className="Junkremovaldetails-content-header">
            <div className="Junkremovaldetails-service-icons">
              <FiTrash size={32} />
            </div>
            <h1 className="Junkremovaldetails-service-title">
              <span className="Junkremovaldetails-title-accent">Junk</span> Removal
            </h1>
          </div>

          <p className="Junkremovaldetails-service-description">
            Junk removal is what we do best. Whether you’re cleaning out a garage, preparing for a move,
            or simply reclaiming space at home or work, our crew handles the heavy lifting and disposal.
            We remove clutter quickly and cleanly, leaving the area ready to use—no sorting, bagging, or
            hauling required. Just point, and we’ll take care of the rest.
          </p>

          <p className="Junkremovaldetails-service-description">
            Our experienced team safely moves bulky items, donates or recycles whenever possible,
            and ensures everything else is disposed of responsibly. From furniture, appliances,
            and household junk to yard waste, office cleanouts, and construction debris, we’ll haul
            away almost anything non-hazardous with ease. With us, you can count on a stress-free
            cleanup and a refreshed space.
          </p>

          <div className="Junkremovaldetails-cta-group">
            <a
              href="https://app.squareup.com/appointments/book/41vplmwf0luh01/LTHMTFD90TMRT/start"
              className="Junkremovaldetails-primary-cta"
              target="_blank"
              rel="noopener noreferrer"
            >
              Schedule Your Pickup
              <span className="Junkremovaldetails-cta-arrow">→</span>
            </a>
          </div>
        </div>

        {/* Image Column */}
        <div className="Junkremovaldetails-image">
          <img
            src={junk}
            alt="Professional junk removal team clearing household items"
            className="Junkremovaldetails-main-image"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default Junkremovaldetails;
